import { Navigate, Route, Routes } from "react-router-dom";
import AuthCallbackPage from "@/app/auth/callback/page";
import DebugEmbeddedYouTubeStep01Page from "@/app/debugging/01-debug-embeded-yt-stream/page";
import DebugEmbeddedYouTubeStep02Page from "@/app/debugging/02-debug-embeded-yt-stream/page";
import DebugEmbeddedYouTubeStep03Page from "@/app/debugging/03-debug-embeded-yt-stream/page";
import DebugEmbeddedYouTubeStep04Page from "@/app/debugging/04-debug-embeded-yt-stream/page";
import DeveloperGdeltPage from "@/app/developer/gdelt/page";
import GeoPressureIntelligencePage from "@/app/geo-pressure/intelligence/page";
import GeoPressureSandboxPage from "@/app/geo-pressure/sandbox/page";
import GlobalPressurePage from "@/app/global-pressure/page";
import Home from "@/app/page";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/debugging/01-debug-embeded-yt-stream" element={<DebugEmbeddedYouTubeStep01Page />} />
      <Route path="/debugging/02-debug-embeded-yt-stream" element={<DebugEmbeddedYouTubeStep02Page />} />
      <Route path="/debugging/03-debug-embeded-yt-stream" element={<DebugEmbeddedYouTubeStep03Page />} />
      <Route path="/debugging/04-debug-embeded-yt-stream" element={<DebugEmbeddedYouTubeStep04Page />} />
      <Route path="/developer/gdelt" element={<DeveloperGdeltPage />} />
      <Route path="/geo-pressure" element={<Navigate replace to="/geo-pressure/intelligence" />} />
      <Route path="/geo-pressure/intelligence" element={<GeoPressureIntelligencePage />} />
      <Route path="/geo-pressure/sandbox" element={<GeoPressureSandboxPage />} />
      <Route path="/global-pressure" element={<GlobalPressurePage />} />
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
  );
}
